import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Image } from "semantic-ui-react";

// OTHER
import { ReactComponent as LogoTelethon7 } from "../../semantic/assets/images/logo-telethon7.svg";

interface ILogo {
  image: ReactNode;
  href?: string;
}

const HeaderTaglineBox = () => {
  const page = useSelector((state: RootState) => state.page);
  const mainImageUrl = page.campaign?.organization?.mainImageUrl;
  // prettier-ignore
  const url = page.campaign?.template?.value?.customSetup?.standaloneDonationForm?.topLogoUrl;

  let logo: ILogo = {
    image: mainImageUrl ? <Image src={mainImageUrl} /> : <LogoTelethon7 />,
    href: url || "https://fundraising.telethon7.com/",
  };

  return (
    <div className="tagline-box">
      <a href={logo.href}>
        <div className="logo">{logo.image}</div>
      </a>
    </div>
  );
};

export default HeaderTaglineBox;
